import { z } from 'zod';

import { PrimaryKeySchema, commaDelimitedList } from './utils';

export const ProjectConversationSchema = z.object({
  projectConversationId: PrimaryKeySchema,
  projectId: PrimaryKeySchema,
  conversationId: PrimaryKeySchema,
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type ProjectConversation = z.infer<typeof ProjectConversationSchema>;

export const ProjectConversationFiltersSchema = z.object({
  projectConversationIds: commaDelimitedList(
    PrimaryKeySchema.array(),
  ).optional(),
  projectIds: commaDelimitedList(PrimaryKeySchema.array()).optional(),
  conversationIds: commaDelimitedList(PrimaryKeySchema.array()).optional(),
});

export type ProjectConversationFilters = z.infer<
  typeof ProjectConversationFiltersSchema
>;
